import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useAdyen } from '../../context/Adyen/context.js';
import '../../context/PaymentsUI/context.js';
import '@swc/helpers';
import '@paypal/react-paypal-js';

function useCheckout(onChange) {
    const { locale  } = useIntl();
    // Import the adyen web module
    const { AdyenModule , clientKey , environment  } = useAdyen();
    const options = React.useMemo(()=>({
            clientKey,
            environment,
            locale: `${locale}`,
            onChange
        })
    , [
        clientKey,
        environment,
        locale,
        onChange
    ]);
    // The checkout object is local to the current page, it needs to be memoized
    // so to handle the dynamic module loading correctly
    const checkout = React.useMemo(()=>{
        const AdyenCheckout = AdyenModule === null || AdyenModule === void 0 ? void 0 : AdyenModule.result;
        return AdyenCheckout && AdyenCheckout(options);
    }, [
        AdyenModule,
        options
    ]);
    return checkout;
}

export { useCheckout as default };
//# sourceMappingURL=useCheckout.js.map
